import { useState, useCallback } from 'react';
import { logger } from '../../utils/logger';
import { fetchDivisionsFromService } from '../../services/Organization/fetchDivisionsFromService';
import { useAuth } from '../../hooks/auth';

export interface Division {
  id: string;
  name: string;
}

export const useFetchDivisions = (orgId: string) => {
  const [divisions, setDivisions] = useState<Division[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { accessToken } = useAuth();

  const fetchDivisions = useCallback(async () => {
    if (!orgId || !accessToken) return;

    setLoading(true);
    setError(null);
    logger.info('Fetching divisions ...', { orgId });

    try {
      const result = await fetchDivisionsFromService(accessToken, orgId);
      setDivisions(result);
      logger.info(`Successfully fetched ${result.length} divisions`, { orgId });
    } catch (err) {
      const msg = err instanceof Error ? err.message : String(err);
      setError(msg);
      logger.error('Error fetching divisions:', { error: msg, orgId });
      setDivisions([]);
    } finally {
      setLoading(false);
    }
  }, [accessToken, orgId]);

  return { divisions, loading, error, fetchDivisions };
};
